import { ossUrl, toUifoxDownload, toWjx, toServiceQQ, toHref } from '@/utils/config.js'

export const bannerList = [
  // {
  //   img: `${ossUrl}/common/official/home-banner10.png`,
  //   btnName: '',
  //   open: toHref('/introduce/eventsPage')
  // }
  {
    img: `${ossUrl}/common/official/home-banner-ome.png`,
    btnName: '',
    open: toHref('/user')
  },
  // {
  //   img: `${ossUrl}/common/official/banner-one.gif`,
  //   btnName: '',
  //   open: toHref('/cps/')
  // },
  {
    img: `${ossUrl}/common/images/banner8.gif`,
    btnName: '',
    open: toHref('/cps/?type=DRAFT')
  },
  {
    img: `${ossUrl}/common/market_v2/home/home-banner9.jpg`,
    btnName: '',
    open: toHref('/cpsqd/?type=DRAFT')
  },
  // {
  //   img: `${ossUrl}/common/official/home-banner-accurate.png`,
  //   conterBtnName: '立即体验',
  //   open: toHref('/track/accurate')
  // }
  // {
  //   img: `${ossUrl}/common/official/home-banner7.png`,
  //   btnName: '',
  //   open: '',
  // },
  // {
  //   img: `${ossUrl}/common/official/home-banner6.png`,
  //   btnName: '',
  //   open: '',
  // },
  {
    img: `${ossUrl}/common/official/home-banner3.png`,
    btnName: '咨询有礼',
    open: toWjx
  }
  // {
  //   img: `${ossUrl}/common/official/home-banner4.png`,
  //   btnName: '立即试用',
  //   open: toServiceQQ,
  // },

  // {
  //   img: require('@/assets/images/api/api.png'),
  //   btnName: '',
  //   open: toHref('/apistore/'),
  // },
]

export const modelItems = {
  send: [
    {
      img: `${ossUrl}/common/market_v2/home/home-send-tab1.png`,
      href: '/vgm',
      title: 'VGM',
      text: '全口岸覆盖 一站式通道',
      code: 'vgm'
    },
    {
      img: `${ossUrl}/common/market_v2/home/home-send-tab2.png`,
      href: '/cps',
      title: '上海-预配舱单',
      text: '快速回执 智能审核',
      code: 'shcps'
    },
    {
      img: `${ossUrl}/common/market_v2/home/home-send-tab2.png`,
      href: '/cpsqd',
      title: '青岛-预配舱单',
      text: '快速回执 智能审核',
      code: 'qdcps'
    },

    {
      img: `${ossUrl}/common/market_v2/home/home-send-tab4.png`,
      href: '/em',
      title: 'EM&ACI',
      text: '提供8000 code，<br/>安全高效，一键发送',
      code: 'em'
    },
    {
      img: `${ossUrl}/common/market_v2/home/home-send-tab5.png`,
      href: '/afr',
      title: 'AFR发送',
      text: '提供AFR code,<br/>快速回执，精准高效',
      code: 'afr'
    },
    {
      img: `${ossUrl}/common/market_v2/home/home-send-tab3.png`,
      href: '/ams',
      title: 'AMS发送',
      text: '提供SCAC code，<br/>无需 FMC Bond，安全简单',
      code: 'ams'
    },
    {
      img: `${ossUrl}/common/market_v2/home/home-send-tab3.png`,
      href: '/isf',
      title: 'ISF发送',
      text: '提供SCAC code，<br/>无需 FMC Bond，安全简单',
      code: 'isf'
    },
    {
      img: `${ossUrl}/common/market_v2/home/home-send-tab3.png`,
      href: '/ics',
      title: 'ICS发送',
      text: '安全简单',
      code: 'ics'
    }
    // {
    //   img: `${ossUrl}/common/market_v2/home/home-send-tab6.png`,
    //   href: '',
    //   title: 'ISF',
    //   text: '敬请期待',
    //   code: '',
    // },
  ],
  track: [
    {
      img: `${ossUrl}/common/market_v2/home/home-tab-1.png`,
      href: '/freight',
      title: '运价查询',
      text: '覆盖全球国际海运费<br/>一站式实时查询',
      code: 'freightRate'
    },
    {
      img: `${ossUrl}/common/market_v2/home/home-tab-2.png`,
      href: '/track',
      title: '箱货跟踪',
      text: '全域管理 周期预测<br/>支持网页版、微信订阅提醒',
      code: 'shTrack'
    },
    {
      img: `${ossUrl}/common/market_v2/home/home-tab-3.png`,
      href: '/track/fullLink',
      title: '全链路跟踪',
      text: '全程可视化跟踪<br/>关键节点实时推送',
      code: 'fullLink'
    }
  ],
  rpa: [
    {
      img: `${ossUrl}/common/rpa_2.0_home/grid-rpa-1.png`,
      routeName: 'rpa',
      title: '企业的数字员工',
      text: '集成各种先进技术，用机器人代替<br/>人力操作，降本增效'
    },
    {
      img: `${ossUrl}/common/rpa_2.0_home/grid-rpa-2.png`,
      routeName: 'rpa',
      title: '应用程序的自动化',
      text: '可以实现任何桌面应用、网页程序<br/>的自动化'
    },
    {
      img: `${ossUrl}/common/rpa_2.0_home/grid-rpa-3.png`,
      routeName: 'rpa',
      title: '鼠标键盘的自动化',
      text: '可以控制鼠标和键盘，替代人力完<br/>成繁琐的流程'
    }
  ]
}

export const scopecodeOne = [
  {
    commonAbbreviations: 'APL',
    shippingCompany: '美国总统',
    remark: '畅接',
    commonShippingAgents: '联代、顺德、航华'
  },
  {
    commonAbbreviations: 'ASL',
    shippingCompany: '亚海',
    remark: '畅接',
    commonShippingAgents: '外代、中联'
  },
  {
    commonAbbreviations: 'BAL',
    shippingCompany: '博亚',
    remark: '畅接',
    commonShippingAgents: '全航线外运'
  },
  {
    commonAbbreviations: 'BSL',
    shippingCompany: '巴拉基',
    remark: '畅接',
    commonShippingAgents: '顺德'
  },
  {
    commonAbbreviations: 'BTL',
    shippingCompany: '孟虎',
    remark: '畅接',
    commonShippingAgents: '全航线外运'
  },
  {
    commonAbbreviations: 'CMA',
    shippingCompany: '达飞',
    remark: '畅接',
    commonShippingAgents: '华港、联代、外运'
  },
  {
    commonAbbreviations: 'CNC',
    shippingCompany: '正利',
    remark: '畅接',
    commonShippingAgents: '全航线外代'
  },
  {
    commonAbbreviations: 'COH',
    shippingCompany: '京汉',
    remark: '畅接',
    commonShippingAgents: '全航线外代'
  },
  {
    commonAbbreviations: 'CSL',
    shippingCompany: '晶品',
    remark: '畅接',
    commonShippingAgents: '全航线外运'
  },
  {
    commonAbbreviations: 'CST',
    shippingCompany: '宝华',
    remark: '畅接，其实是CNC的台湾线品牌',
    commonShippingAgents: '全航线外代'
  },
  {
    commonAbbreviations: 'DJS',
    shippingCompany: '东进',
    remark: '外运可以，振华发不了',
    commonShippingAgents: '振华、外运'
  },
  {
    commonAbbreviations: 'DY',
    shippingCompany: '东映',
    remark: '畅接',
    commonShippingAgents: '全航线外运'
  },
  {
    commonAbbreviations: 'EMC/EVG',
    shippingCompany: '长荣',
    remark: '除了MCT和HDT航线，（台湾线）不能接。 其他航线畅接',
    commonShippingAgents: 'MCT和HDT航线中联代理，其余全航线航华'
  },
  {
    commonAbbreviations: 'ESL',
    shippingCompany: '阿联酋',
    remark: '畅接',
    commonShippingAgents: '全航线华港'
  },
  {
    commonAbbreviations: 'FESCO/FSC',
    shippingCompany: '俄远东',
    remark: '畅接',
    commonShippingAgents: '全航线外代'
  },
  {
    commonAbbreviations: 'HAL',
    shippingCompany: '兴亚',
    remark: '畅接',
    commonShippingAgents: '外运、外代、振华、锦诚'
  },
  {
    commonAbbreviations: 'HLC/HPL',
    shippingCompany: '赫伯罗特',
    remark: '畅接',
    commonShippingAgents: '联代、华港、中联'
  },
  {
    commonAbbreviations: 'HMM',
    shippingCompany: '现代',
    remark: '畅接',
    commonShippingAgents: '全航线鹏海。'
  },
  {
    commonAbbreviations: 'HSD/HAM',
    shippingCompany: '汉堡南美',
    remark: '畅接',
    commonShippingAgents: '鹏华、航华'
  },
  {
    commonAbbreviations: 'STX/POL',
    shippingCompany: '泛奥昇',
    remark: '畅接',
    commonShippingAgents: '全航线外运'
  },
  {
    commonAbbreviations: 'KKC',
    shippingCompany: '神原',
    remark: '畅接',
    commonShippingAgents: '全航线外代'
  },
  {
    commonAbbreviations: 'KMTC/KMT',
    shippingCompany: '高丽',
    remark: '畅接',
    commonShippingAgents: '外代、外运、中联'
  },
  {
    commonAbbreviations: 'MAT',
    shippingCompany: '美森',
    remark: '畅接',
    commonShippingAgents: '全航线联代'
  },
  {
    commonAbbreviations: 'MBF',
    shippingCompany: '卡朋特',
    remark: '畅接',
    commonShippingAgents: '全航线外运'
  },
  {
    commonAbbreviations: 'MEL',
    shippingCompany: '玛丽安娜',
    remark: '畅接',
    commonShippingAgents: '外运'
  },
  {
    commonAbbreviations: 'MSK',
    shippingCompany: '马士基',
    remark: '畅接',
    commonShippingAgents: '全航线联代代理'
  }
]

export const scopecodeTwo = [
  {
    commonAbbreviations: 'NDS',
    shippingCompany: '尼罗河',
    remark: '畅接',
    commonShippingAgents: '航华'
  },
  {
    commonAbbreviations: 'NOS',
    shippingCompany: '新东',
    remark: '畅接，仁川线必须用NSI作为代码，宁波远洋',
    commonShippingAgents: '全航线外代'
  },
  {
    commonAbbreviations: 'NZL',
    shippingCompany: '新西兰航运',
    remark: '畅接',
    commonShippingAgents: '全航线振华'
  },
  {
    commonAbbreviations: 'ONE',
    shippingCompany: '海洋网联',
    remark: '畅接',
    commonShippingAgents: '联代、华港、外运、外代、中联'
  },
  {
    commonAbbreviations: 'OOCL',
    shippingCompany: '东方海外',
    remark: '畅接',
    commonShippingAgents: '东方海外'
  },
  {
    commonAbbreviations: 'PEL',
    shippingCompany: '普尔玛',
    remark: '畅接',
    commonShippingAgents: '顺德'
  },
  {
    commonAbbreviations: 'PIL',
    shippingCompany: '太平',
    remark: '畅接',
    commonShippingAgents: '外运、华港'
  },
  {
    commonAbbreviations: 'PMA',
    shippingCompany: '普洱玛',
    remark: '畅接',
    commonShippingAgents: '全航线顺德'
  },
  {
    commonAbbreviations: 'RCL',
    shippingCompany: '宏海箱运',
    remark: '畅接',
    commonShippingAgents: '顺德、外代'
  },
  {
    commonAbbreviations: 'SCI',
    shippingCompany: '印度国航',
    remark: '畅接',
    commonShippingAgents: '全航线外代'
  },
  {
    commonAbbreviations: 'SCO',
    shippingCompany: '新加坡海运',
    remark: '畅接，其实是边行BENLINE的子品牌',
    commonShippingAgents: '外代、华港'
  },
  {
    commonAbbreviations: 'SLS（FCSL）',
    shippingCompany: '新加坡海领',
    remark: '畅接',
    commonShippingAgents: '华港'
  },
  {
    commonAbbreviations: 'SMH',
    shippingCompany: '司马泰',
    remark: '畅接',
    commonShippingAgents: '顺德'
  },
  {
    commonAbbreviations: 'SML',
    shippingCompany: '森罗',
    remark: '畅接',
    commonShippingAgents: '外运、联代'
  },
  {
    commonAbbreviations: 'SNKO',
    shippingCompany: '长锦',
    remark: '畅接',
    commonShippingAgents: '全航线外运'
  },
  {
    commonAbbreviations: 'SNL',
    shippingCompany: '外运集运',
    remark: '畅接',
    commonShippingAgents: '全航线外运'
  },
  {
    commonAbbreviations: 'SOF',
    shippingCompany: '顺发',
    remark: '畅接',
    commonShippingAgents: '全航线外代'
  },
  {
    commonAbbreviations: 'SSL',
    shippingCompany: '萨姆达拉',
    remark: '畅接',
    commonShippingAgents: '外代'
  },
  {
    commonAbbreviations: 'POL',
    shippingCompany: '泛洋',
    remark: '畅接',
    commonShippingAgents: '外运'
  },
  {
    commonAbbreviations: 'SWIR',
    shippingCompany: '太古',
    remark: '畅接',
    commonShippingAgents: '鹏华、外运'
  },
  {
    commonAbbreviations: 'TSL/TSC',
    shippingCompany: '德翔',
    remark: '中联代理的航线不能发，其他畅接',
    commonShippingAgents: '外代、中联、顺德'
  },
  {
    commonAbbreviations: 'TYS',
    shippingCompany: '太荣',
    remark: '畅接',
    commonShippingAgents: '全航线外运'
  },
  {
    commonAbbreviations: 'WHL',
    shippingCompany: '万海',
    remark: '畅接',
    commonShippingAgents: '中联、联代 、外代、华港（台湾线民生代理）'
  },
  {
    commonAbbreviations: 'WOSCO',
    shippingCompany: '西联',
    remark: '畅接',
    commonShippingAgents: '全航线外运'
  },
  {
    commonAbbreviations: 'YML',
    shippingCompany: '阳明',
    remark: '畅接',
    commonShippingAgents: '外运、外代、中联、联代'
  },
  {
    commonAbbreviations: 'ZIM',
    shippingCompany: '以星',
    remark: '畅接',
    commonShippingAgents: '航华、顺德'
  }
]

export const shippingAgentList = [
  {
    shippingAgent: '上海中外运'
  },
  {
    shippingAgent: '上海中联'
  },
  {
    shippingAgent: '上海华港'
  },
  {
    shippingAgent: '上海外代'
  },
  {
    shippingAgent: '上海振华'
  },
  {
    shippingAgent: '上海民生'
  },
  {
    shippingAgent: '上海航华'
  },
  {
    shippingAgent: '上海顺德'
  },
  {
    shippingAgent: '上海鹏华'
  },
  {
    shippingAgent: '上海鹏海'
  },
  {
    shippingAgent: '上港联合'
  },
  {
    shippingAgent: '东方海外'
  },
  {
    shippingAgent: '新海'
  },
  {
    shippingAgent: '锦诚'
  }
]
